import SinglePage from './components/SinglePage/SinglePage';
import PopupPage from './components/PopupPage/PopupPage';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import FJNetworkStore from './store/FJNetworkStore';
import FJAction from './action/FJAction';
import FJUtil from './util/FJUtil';

const AppContent = props => {
    const dispatch = useDispatch();
    const state = useSelector(state => {
        return {
            show: state.mainStore.show,
            method: state.mainStore.method,
            page: state.mainStore.page,
        };
    });

    useEffect(() => {
        const email = FJUtil.getQueryString('email');
        if (email) {
            dispatch(FJAction.changeEmail(email));
        }
    }, []);
    return state.show ? (
        <div style={{ height: '100%' }}>
            {state.method === 'single' && <SinglePage page={state.page} />}
            {state.method !== 'single' && <PopupPage page={state.page} />}
        </div>
    ) : null;
};
export default AppContent;
